import { takeLatest, put, call, select } from 'redux-saga/effects';
import { get } from 'lodash';
import {
  getProductsAction,
  getUserSubscriptionsAction,
  getBankCardsAction,
  cancelSubscriptionAction,
  addSubscriptionAction,
} from './actions';
import * as API from '../../utils/API';
import { enqueueSnackbarAction } from '../App/actions';
import { selectUserData } from '../App/selectors';

export function* getProductsSaga() {
  try {
    const response = yield call(API.getProductsList);
    yield put(getProductsAction.success(get(response, 'data.data', [])));
  } catch (e) {
    yield put(getProductsAction.failure(e));
  } finally {
    yield put(getProductsAction.fulfill());
  }
}

export function* getUserSubscriptionsSaga() {
  try {
    const userData = yield select(selectUserData());
    const userId = get(userData, 'id');
    if (!userId) {
      throw new Error('User undefined');
    }
    const response = yield call(API.getUserSubscriptions, userId);
    yield put(getUserSubscriptionsAction.success(get(response, 'data.data', [])));
  } catch (e) {
    yield put(getUserSubscriptionsAction.failure(e));
  } finally {
    yield put(getUserSubscriptionsAction.fulfill());
  }
}

export function* cancelUserSubscriptionSaga({ payload }) {
  try {
    if (!payload.userId) {
      throw new Error('User undefined');
    }
    if (!payload.subId) {
      throw new Error('Subscription id is undefined');
    }
    const response = yield call(API.cancelUserSubscription, payload.userId, payload.subId);
    yield call(getUserSubscriptionsSaga);
    yield put(cancelSubscriptionAction.success());
  } catch (e) {
    yield put(cancelSubscriptionAction.failure(e));
  } finally {
    yield put(cancelSubscriptionAction.fulfill());
  }
}

export function* addUserSubscriptionSaga({ payload }) {
  try {
    if (!payload.userId) {
      throw new Error('User undefined');
    }
    if (!payload.subdata) {
      throw new Error('Subscription is undefined');
    }
    const response = yield call(API.addUserSubscription, payload.userId, payload.subdata);
    yield call(getUserSubscriptionsSaga);
    yield put(addSubscriptionAction.success());
  } catch (e) {
    yield put(
      enqueueSnackbarAction.trigger({
        message: e.message,
        options: {
          variant: 'error',
        },
      }),
    );
    yield put(addSubscriptionAction.failure(e));
  } finally {
    yield put(addSubscriptionAction.fulfill());
  }
}

export function* getUserBankCardsSaga() {
  try {
    const userData = yield select(selectUserData());
    const userId = get(userData, 'id');
    if (!userId) {
      throw new Error('User undefined');
    }
    const response = yield call(API.getUserBankCards, userId);
    yield put(getBankCardsAction.success(get(response, 'data')));
  } catch (e) {
    yield put(getBankCardsAction.failure(e));
  } finally {
    yield put(getBankCardsAction.fulfill());
  }
}

export default function* accountSubscriptionSagas() {
  yield takeLatest(getProductsAction.TRIGGER, getProductsSaga);
  yield takeLatest(getUserSubscriptionsAction.TRIGGER, getUserSubscriptionsSaga);
  yield takeLatest(getBankCardsAction.TRIGGER, getUserBankCardsSaga);
  yield takeLatest(cancelSubscriptionAction.TRIGGER, cancelUserSubscriptionSaga);
  yield takeLatest(addSubscriptionAction.TRIGGER, addUserSubscriptionSaga);
}
